import { apiClient } from '../utils/api';

export async function getFormByFormId(id, appointmentChannelId = null) {
    if (id == null || id === '') {
        return Promise.reject(new Error('Form ID is required. Pass form_id (or form) in the URL, e.g. ?form_id=YOUR_FORM_ID'));
    }
    return await apiClient.GET(`api/channels/widget/${id}${appointmentChannelId ? '?appointment_channel_id=' + appointmentChannelId : ''}`);
}
